<template>
  <div class="main">
    欢迎登录。
		
  </div>

</template>

<script>
  import * as util from '@/utils/util.js';
  import { mapState } from 'vuex';


  export default {
    data() {
      return {
        redirect: '',
				data:[],
				muluList: [],
				currentKey: '',
				emptyText: '',
				expandedKeys: ['0'],
				
      }
    },
    created() {
      
    },
    methods: {
			
    }
  }
</script>

<style lang="scss" scoped="scoped">
.main {
	padding: 30px 0px;
	font-size: 25px;
  border: 0px solid #F0C78A;
}
</style>
<style lang="scss">

</style>
